"use client";

import { PATHS } from "@/constants/pathnames";
import { Link } from "@/i18n/navigation";
import { getLocalizedPath } from "@/utils/pathUtils";
import { slugify } from "@/utils/slugify";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";

function pushCtaClickDataLayer(dataLayerPayload, cta_button) {
  if (typeof window === "undefined" || !dataLayerPayload) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...dataLayerPayload,
    cta_button: cta_button ?? "",
  });
}

export default function DestinationCard({
  item = {},
  dataLayerPayload = null,
}) {
  const locale = useLocale();
  const tCommon = useTranslations("common");

  const {
    // Eski yapı
    RedirectUrl,
    Title,
    IconImage,
    AnchorTitle,
    // Yeni API yapısı
    LocationText,
    FlightSlug,
    BusSlug,
    HotelSlug,
    CarSlug,
    Image: NewImage,
  } = item;

  const title = Title || LocationText || "";
  const image = IconImage || NewImage || {};
  const linkTitle = AnchorTitle || title || "";
  const slug = (slugify(title) || "destination").toLowerCase();

  // Eski veriler için fallback
  const defaultHref = RedirectUrl || "#";

  const flightBasePath = getLocalizedPath(PATHS.FLIGHT_TICKET.PATH, locale);
  const busBasePath = getLocalizedPath(PATHS.BUS_TICKET.PATH, locale);
  const hotelBasePath = getLocalizedPath(PATHS.HOTEL.PATH, locale);

  const flightHref = FlightSlug
    ? `${flightBasePath}/${FlightSlug}`
    : defaultHref;
  const busHref = BusSlug ? `${busBasePath}/${BusSlug}` : defaultHref;
  const hotelHref = HotelSlug ? `${hotelBasePath}/${HotelSlug}` : defaultHref;

  const carHref = CarSlug || defaultHref;

  return (
    <article className="border-primary-weak flex h-full w-full flex-col overflow-hidden rounded-lg border bg-white">
      {/* Image */}
      <div className="relative h-[240px] w-full">
        {image?.ImageUrl && (
          <Image
            src={image.ImageUrl}
            alt={image.ImageAlt || title || "Destination"}
            fill
            sizes="(min-width: 768px) 320px, 100vw"
            className="object-cover"
          />
        )}

        {/* Gradient overlay */}
        <div className="gradient-overlay absolute inset-0" />

        {/* Title */}
        {title && (
          <h3 className="absolute bottom-[15px] left-5 z-10 text-xl font-semibold text-white">
            {title}
          </h3>
        )}
      </div>

      {/* Actions */}
      <div className="px-4 py-4 md:px-5">
        <ul className="text-foreground-default flex flex-nowrap items-center justify-between">
          <li>
            <Link
              href={flightHref}
              title={linkTitle}
              className="hover:text-primary text-base leading-21 font-semibold"
              onClick={() =>
                dataLayerPayload &&
                pushCtaClickDataLayer(dataLayerPayload, `${slug}_flight`)
              }
            >
              {tCommon("destinationCardTitleFlight")}
            </Link>
          </li>
          <li className="bg-foreground-muted h-1 w-1 rounded-full" />
          <li>
            <Link
              href={busHref}
              title={linkTitle}
              className="hover:text-primary text-base leading-21 font-semibold"
              onClick={() =>
                dataLayerPayload &&
                pushCtaClickDataLayer(dataLayerPayload, `${slug}_bus`)
              }
            >
              {tCommon("destinationCardTitleBus")}
            </Link>
          </li>
          <li className="bg-foreground-muted h-1 w-1 rounded-full" />
          <li>
            <Link
              href={hotelHref}
              title={linkTitle}
              className="hover:text-primary text-base leading-21 font-semibold"
              onClick={() =>
                dataLayerPayload &&
                pushCtaClickDataLayer(dataLayerPayload, `${slug}_hotel`)
              }
            >
              {tCommon("destinationCardTitleHotel")}
            </Link>
          </li>
          <li className="bg-foreground-muted h-1 w-1 rounded-full" />
          <li>
            <Link
              href={carHref}
              title={linkTitle}
              className="hover:text-primary text-base leading-21 font-semibold"
              onClick={() =>
                dataLayerPayload &&
                pushCtaClickDataLayer(dataLayerPayload, `${slug}_car`)
              }
            >
              {tCommon("destinationCardTitleCar")}
            </Link>
          </li>
          {/* <li className="h-1 w-1 rounded-full bg-foreground-muted" />
          <li>
            <Link
              href={carHref}
              title={linkTitle}
              className="font-semibold text-base leading-21 hover:text-primary"
              onClick={() => dataLayerPayload && pushCtaClickDataLayer(dataLayerPayload, `${slug}_ferry`)}
            >
              {tCommon("destinationCardTitleFerry")}
            </Link>
          </li> */}
        </ul>
      </div>
    </article>
  );
}
